import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M4 9h16v2H4zm0 4h10v2H4z"
}), 'ShortTextTwoTone');